<template>
    <div class="pb-6 text-center">
        <div
            @click.stop.prevent="goToLink(variant.buyLink)"
            v-for="variant in variants"
            :key="variant.id"
            class="relative cursor-pointer mb-4 rounded-sm transform transition hover:scale-102 h-14 max-w-2xl mx-auto flex items-center justify-center"
            :style="{
                'background-color': pricing.backColor,
                'box-shadow': `0 0 0 0px #fff, 0 0 0 ${variant.highlight ? '2px' : '1px'} ${
                    variant.highlight ? pricing.highlightColor : pricing.borderColor
                }, 0 0 #0000`,
                'border-radius': `${pricing.borderRadius}px`,
            }"
        >
            <div v-if="variant.img" class="absolute m-1 h-12 w-12 top-0 left-0">
                <cUtilsEdit @edit="goToVariantField(variant.id, 'variantImg')">
                    <img class="h-12 mx-auto rounded-sm object-cover" :src="variant.img" />
                </cUtilsEdit>
            </div>

            <div
                v-if="variant.title"
                class="text-base font-medium text-center pl-16 pr-2"
                :style="{ color: pricing.headingsColor }"
            >
                <cUtilsEdit @edit="goToVariantField(variant.id, 'variantTitle')">
                    <MarkdownHtml :markdown="variant.title" />
                </cUtilsEdit>
            </div>
        </div>
    </div>
</template>

<script>
import { MarkdownHtml } from "@easy/ui/text";
import { hexToRgba } from "@/shared/utils/helpers";
import { usePricingGoTo } from "@/views/tools/pricing/utils/usePricingGoTo";
import { useGoToLink } from "@/shared/utils/router/useGoToLink";
import cUtilsEdit from "@/views/shared/cUtilsEdit.vue";

export default {
    name: "LinksLayout",
    props: {
        pricing: Object,
        variants: Array,
    },
    components: {
        cUtilsEdit,
        MarkdownHtml,
    },
    setup() {
        const { goToLink } = useGoToLink("_self");
        const { goToVariantField } = usePricingGoTo();
        return {
            goToVariantField,
            goToLink,
        };
    },
    methods: {
        hexToRgba,
    },
};
</script>
